import React from 'react';
import PropTypes from 'prop-types';
import {useDispatch} from 'react-redux';
import Notification from '~/components/Notification';
import {resetInkMatches} from '~/actions/DesignActions';
import {Stack, Button} from '@customink/pigment-react';
import {metrics} from '~/vendor/metrics';
import {swapProduct} from '~/actions/ProductActions';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export default function PantoneDisabledWarning({dismiss, notification}) {
  const dispatch = useDispatch();
  const attemptedSwap = notification?.payload?.swapArgs;

  const cancel = () => {
    metrics.pageViewTag('/ndx/upload/pantone/alert/cancel');
    dismiss();
  };

  const confirm = () => {
    dispatch(resetInkMatches());
    dispatch(swapProduct(...attemptedSwap));
    metrics.pageViewTag('/ndx/upload/pantone/alert/success');
    dismiss();
  };

  return (
    <Notification title="Head's up!" dismiss={cancel}>
      <p className="ndx-cta1">
        This product is not enabled for Pantone matching. Changing the product
        will remove the Pantone color(s).
      </p>
      <Stack className="notification-stack">
        <Button size="large" onClick={confirm}>
          Yes, Remove
        </Button>
        <Button
          size="large"
          sx={{marginTop: '0.5rem'}}
          variant="link"
          onClick={cancel}>
          Cancel
        </Button>
      </Stack>
    </Notification>
  );
}

const propTypes = {
  dismiss: PropTypes.func,
  notification: PropTypes.object
};

PantoneDisabledWarning.propTypes = propTypes;
